<template>
  <div class="anxin-cloud">
    <section class="hero">
      <div class="heroInner">
        <div class="heroContent">
          <h1>专为工贸、维保企业<br />打造的轻量级灵活用工管理SaaS</h1>
          <img src="@/assets/anxinyun/slice-39.png" alt="" class="heroLabel" />
          <img src="@/assets/anxinyun/slice-40.png" alt="" class="heroChecks" />
          <div class="heroActions">
            <button class="primaryBtn">免费试用</button>
            <button class="ghostBtn">联系销售</button>
          </div>
        </div>
      </div>
    </section>

    <section class="stats">
      <div class="statItem">
        <div class="statLabel">服务企业客户</div>
        <div class="statValue">9000<span>家+</span></div>
      </div>
      <div class="statItem">
        <div class="statLabel">服务蓝领员工</div>
        <div class="statValue">100<span>万+</span></div>
      </div>
      <div class="statItem">
        <div class="statLabel">累计发薪量</div>
        <div class="statValue">200<span>亿+</span></div>
      </div>
      <div class="statItem">
        <div class="statLabel">客户口碑推荐</div>
        <div class="statValue">96<span>%</span></div>
      </div>
    </section>

    <section class="intro">
      <h2>安心云是谁？</h2>
      <p>
        安心云是民匠有约（应急管理部星火计划项目）全资自研的企业端灵活用工SaaS管理工具。
      </p>
      <img src="@/assets/anxinyun/slice-42.png" alt="" class="introBanner" />
      <div class="introCards">
        <div v-for="item in introList" :key="item.name" class="introCard">
          <img :src="item.icon" alt="" />
          <div>{{ item.name }}</div>
          <span>{{ item.desc }}</span>
        </div>
      </div>
    </section>

    <section class="core">
      <h2>五大核心能力，一站式解决灵活用工管理难题？</h2>
      <div class="corePanel">
        <div class="coreTabs">
          <div
            v-for="(item, index) in coreTabs"
            :key="item.title"
            :class="['coreTab', { active: index === activeCoreIndex }]"
            @click="activeCoreIndex = index"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="coreContent">
          <h3>{{ activeCore.title }}</h3>
          <p v-for="text in activeCore.desc" :key="text">{{ text }}</p>
        </div>
      </div>
    </section>

    <section class="industry">
      <h2>精准服务五大行业</h2>
      <div
        class="industryCarousel"
        @mouseenter="pauseIndustryCarousel"
        @mouseleave="startIndustryCarousel"
      >
        <div class="industryTrack">
          <img
            v-for="(item, index) in industryDisplayList"
            :key="`${item}-${index}`"
            :src="item"
            alt=""
            :class="['industrySlide', { active: index === 2 }]"
          />
        </div>
      </div>
    </section>

    <section class="security">
      <h2>国家级项目背书，安全可靠</h2>
      <img src="@/assets/anxinyun/slice-41.png" alt="" />
    </section>

    <section class="contact">
      <h2>让灵活用工管理更简单、更安心</h2>
      <div class="contactActions">
        <button>免费试用</button>
        <button>预约演示</button>
        <button class="outline">联系销售</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      introList: [
        {
          name: "服务企业客户",
          desc: "工人私活，服务于外包",
          icon: require("@/assets/anxinyun/slice-43.png"),
        },
        {
          name: "内部管控",
          desc: "任务制用工，全程留痕",
          icon: require("@/assets/anxinyun/slice-47.png"),
        },
        {
          name: "业务留痕",
          desc: "司法认证链路，可作维权凭据",
          icon: require("@/assets/anxinyun/slice-44.png"),
        },
        {
          name: "风险隔离",
          desc: "大幅降低劳动关系判定风险",
          icon: require("@/assets/anxinyun/slice-46.png"),
        },
        {
          name: "合规辅助",
          desc: "适配合规用工监管要求",
          icon: require("@/assets/anxinyun/slice-45.png"),
        },
      ],
      activeCoreIndex: 0,
      coreTabs: [
        {
          title: "智能电子签约 + 司法存证",
          desc: [
            "任务制劳务协议、承揽合作协议在线签署",
            "全流程留痕，证据链可直接用于劳动仲裁",
            "大幅降低事实劳动关系判定风险",
          ],
        },
        {
          title: "人脸识别 + 定位外勤考勤",
          desc: [
            "专为维保、巡检、促销等外勤场景设计",
            "防代打卡、作业留痕、实时定位",
            "人员动态、工时记录一目了然",
          ],
        },
        {
          title: "特种作业资质核验",
          desc: [
            "电工、制冷、特种设备操作证在线核验",
            "证件到期自动预警，入驻比对",
            "帮助规避监管部门高额罚款",
          ],
        },
        {
          title: "百万保额工人意外险",
          desc: [
            "蓝领专属定制保障，百万保额",
            "支持按天、按月、按单灵活投保",
            "性价比行业领先，专人协助理赔",
          ],
        },
        {
          title: "模块化自由适配",
          desc: [
            "管控、保险两大模块自由拆分",
            "不捆绑、不加价，用多少付多少",
            "极致贴合中小企业减压半用工节奏",
          ],
        },
      ],
      industryActiveIndex: 0,
      industryTimer: null,
      industryList: [
        require("@/assets/anxinyun/slice-50.png"),
        require("@/assets/anxinyun/slice-51.png"),
        require("@/assets/anxinyun/slice-52.png"),
        require("@/assets/anxinyun/slice-53.png"),
        require("@/assets/anxinyun/slice-54.png"),
      ],
    };
  },
  computed: {
    activeCore() {
      return this.coreTabs[this.activeCoreIndex];
    },
    industryDisplayList() {
      const length = this.industryList.length;
      return [-2, -1, 0, 1, 2].map((offset) => {
        const index = (this.industryActiveIndex + offset + length) % length;
        return this.industryList[index];
      });
    },
  },
  mounted() {
    this.startIndustryCarousel();
  },
  beforeDestroy() {
    this.pauseIndustryCarousel();
  },
  methods: {
    startIndustryCarousel() {
      this.pauseIndustryCarousel();
      this.industryTimer = setInterval(() => {
        this.industryActiveIndex =
          (this.industryActiveIndex + 1) % this.industryList.length;
      }, 2500);
    },
    pauseIndustryCarousel() {
      if (this.industryTimer) {
        clearInterval(this.industryTimer);
        this.industryTimer = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.anxin-cloud {
  min-width: 1200px;
  background: #ffffff;
  color: #141414;
  overflow: hidden;
}
.hero {
  height: 560px;
  background: #eef6ff url("@/assets/anxinyun/slice-48.png") center top / 1920px
    580px no-repeat;
}
.heroInner {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.heroContent {
  position: absolute;
  left: 0;
  top: 105px;
  z-index: 2;
  text-align: left;
  h1 {
    margin: 0 0 24px;
    font-weight: 800;
    font-size: 42px;
    color: #0f172a;
    line-height: 56px;
    letter-spacing: 1px;
  }
}
.heroLabel {
  width: 696px;
  height: 40px;
  display: block;
  object-fit: contain;
  margin-bottom: 14px;
}
.heroChecks {
  width: 496px;
  height: 28px;
  display: block;
  object-fit: contain;
  margin-bottom: 34px;
}
.heroActions {
  display: flex;
  align-items: center;
  button {
    width: 120px;
    height: 42px;
    border-radius: 22px;
    font-weight: 500;
    font-size: 16px;
    cursor: pointer;
  }
}
.primaryBtn {
  margin-right: 28px;
  border: none;
  color: #ffffff;
  background: #0877ff;
}
.ghostBtn {
  color: #0877ff;
  border: 1px solid #0877ff;
  background: #ffffff;
}
.stats {
  position: relative;
  z-index: 3;
  width: 1230px;
  height: 150px;
  margin: -44px auto 66px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  padding: 0 44px;
  background: #ffffff;
  box-shadow: 0 8px 28px rgba(37, 99, 235, 0.08);
}
.statItem {
  flex: 1;
  text-align: center;
  position: relative;
  &:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    width: 1px;
    height: 46px;
    background: #eef2f7;
    transform: translateY(-50%);
  }
}
.statLabel {
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 15px;
  color: #141414;
}
.statValue {
  font-weight: 800;
  font-size: 34px;
  line-height: 40px;
  color: #020617;
  span {
    margin-left: 4px;
    font-weight: 600;
    font-size: 14px;
    color: #141414;
  }
}
.intro {
  width: 1200px;
  margin: 0 auto 92px;
  text-align: center;
  h2 {
    margin: 0 0 20px;
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
  }
  p {
    margin: 0 auto 30px;
    width: 900px;
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
    color: #141414;
  }
}
.introBanner {
  width: 1200px;
  height: 109px;
  display: block;
  margin-bottom: 0;
}
.introCards {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: -1px;
}
.introCard {
  width: 200px;
  height: 190px;
  box-sizing: border-box;
  padding-top: 36px;
  background: #f5f8ff;
  border-radius: 4px;
  img {
    width: 66px;
    height: 66px;
    margin-bottom: 20px;
  }
  div {
    font-weight: 700;
    font-size: 17px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  span {
    font-size: 12px;
    color: #64748b;
  }
}
.core {
  padding: 84px 0 64px;
  background: linear-gradient(90deg, #f8fbff 0%, #ffffff 50%, #f8fbff 100%);
  text-align: center;
  h2 {
    margin: 0 0 58px;
    font-weight: 800;
    font-size: 32px;
    line-height: 44px;
  }
}
.corePanel {
  width: 1200px;
  height: 486px;
  margin: 0 auto;
  display: flex;
  background: #ffffff;
}
.coreTabs {
  width: 460px;
  height: 486px;
  background: #ffffff;
}
.coreTab {
  height: 97px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 17px;
  color: #141414;
  border-bottom: 1px solid #edf2f7;
  cursor: pointer;
  &.active {
    height: 78px;
    color: #ffffff;
    background: #0877ff;
  }
}
.coreContent {
  flex: 1;
  height: 486px;
  box-sizing: border-box;
  padding: 112px 0 0 164px;
  text-align: left;
  background: url("@/assets/anxinyun/slice-49.png") center / cover no-repeat;
  h3 {
    margin: 0 0 42px;
    font-weight: 800;
    font-size: 32px;
    line-height: 44px;
  }
  p {
    margin: 0 0 22px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
}
.industry {
  padding: 48px 0 76px;
  text-align: center;
  h2 {
    margin: 0 0 50px;
    font-weight: 800;
    font-size: 32px;
    line-height: 44px;
  }
}
.industryCarousel {
  width: 1200px;
  height: 430px;
  margin: 0 auto;
  overflow: hidden;
}
.industryTrack {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
}
.industrySlide {
  flex: 0 0 224px;
  width: 224px;
  height: 280px;
  border-radius: 4px;
  object-fit: cover;
  transition: width 0.45s ease, height 0.45s ease, transform 0.45s ease,
    box-shadow 0.45s ease;
  &.active {
    flex-basis: 310px;
    width: 310px;
    height: 370px;
    transform: translateY(-10px);
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.22);
  }
}
.security {
  height: 800px;
  box-sizing: border-box;
  padding-top: 48px;
  background: #0963ff;
  overflow: hidden;
  text-align: center;
  h2 {
    margin: 0 0 22px;
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
    color: #ffffff;
  }
  img {
    width: 1200px;
    height: 644px;
    display: block;
    margin: 0 auto;
    object-fit: contain;
  }
}
.contact {
  padding: 82px 0 120px;
  text-align: center;
  h2 {
    margin: 0 0 42px;
    font-weight: 800;
    font-size: 32px;
    line-height: 44px;
  }
}
.contactActions {
  display: flex;
  justify-content: center;
  gap: 82px;
  button {
    width: 150px;
    height: 42px;
    border: none;
    border-radius: 21px;
    color: #ffffff;
    background: #0877ff;
    font-size: 16px;
    cursor: pointer;
    &.outline {
      color: #0877ff;
      border: 1px solid #0877ff;
      background: #ffffff;
    }
  }
}
</style>
